
import headerComponent from '~/components/headerComponent.vue';
import getErrorTranslationKey from '~/utils/getErrorTranslationKey';

export default {
    name: 'NuxtError',
    components: {
        headerComponent,
    },
    props: {
        /** @type {import('vue').PropOptions<OfferWeb.ClientApiError>} */
        error: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            /** @type {OfferWeb.ClientSideUser | null} */
            user: null,
            /** @type {import('@tidal/user-middleware').AppMode | null} */
            appMode: null,
        };
    },
    async fetch() {
        /** @type {OfferWeb.PageDataEndpoint} */
        const { user, appMode } = await this.$axios.$get('/api/page-data');

        this.user = user;
        this.appMode = appMode;
    },
    head() {
        return {
            htmlAttrs: {
                lang: this.$i18n.locale,
            },
        };
    },
    computed: {
        /** @returns {[string, any][]} */
        errorProps() {
            return Object.entries(this.error).filter(([_key, value]) => Boolean(value));
        },
        /** @returns {string} */
        message() {
            return this.$t(getErrorTranslationKey(this.error.messageCode));
        },
    },
};
